<template>
    <div class="form">
        <div class="vcore_row">
            <div class="vcore_col--md--12">
                <div class="title">New User</div>
            </div>
        </div>
        <div class="vcore_row">
            <div class="vcore_col--md--4 vcore_col--sm--12">
                <div class="vcore_input-group">
                    <label class="vcore_input-label">Username</label>
                    <input
                            type="text"
                            class="vcore_input"
                            :value="loginUsername"
                            @input="loginUsernameUpdate"
                    />
                </div>
            </div>
            <div class="vcore_col--md--4 vcore_col--sm--12">
                <div class="vcore_input-group">
                    <label class="vcore_input-label">Password</label>
                    <input
                            type="text"
                            class="vcore_input"
                            :value="loginPw"
                            @input="loginPwUpdate"
                    />
                </div>
            </div>
            <div class="vcore_col--md--4 vcore_col--sm--12">
                <div class="vcore_input-group">
                    <label class="vcore_input-label">Permissions</label>
                    <select
                            class="admin-select"
                            id="admin"
                            v-model="adminSelect"
                    >
                        <option value="User">User</option>
                        <option value="Admin">Admin</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="vcore_row button-row">
            <div class="vcore_col--xs--12">
                <button
                        class="vcore_btn vcore_btn--primary md-button blue-button"
                        type="button"
                        @click="newUser"
                >Submit</button>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";
    export default {
        name: "AdminSettings",
        computed: {
            ...mapGetters([
                "loginUsername",
                "loginPw"
            ]),
        },
        data(){
            return {
                adminSelect: "User"
            }
        },
        methods: {
            loginUsernameUpdate(e){
                this.$store.commit("loginUsernameUpdate", e.target.value);
            },
            loginPwUpdate(e){
                this.$store.commit("loginPwUpdate", e.target.value);
            },
            newUser(){
                this.$store.dispatch("newUser", this.adminSelect);
            }
        },
        mounted(){
            this.$store.commit("loginUsernameUpdate", "");
            this.$store.commit("loginPwUpdate", "");
        }
    }
</script>

<style lang="scss" scoped>
    .no-padding-left {
        padding-left: 0;
    }

    .vcore_input-label {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 24px;
        line-height: 33px;
        float: left;
        color: $color_black;
    }

    .divider {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 28px;
        line-height: 38px;
        text-align: left;
        color: $color_gray-3;
        margin-top: 25px;
    }

    .vcore_input-addon {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        //float: left;
        color: $color_gray-4;
    }

    .underline {
        position: relative;
        top: 3px;
    }

    .admin-select {
        height: 40px;
        padding: 10px;
        line-height: 18px;
        width: 100%;
    }

    .button-row {
        margin-top: 15px;
        margin-bottom: 5px;
    }

    .vcore_btn {
        float: right;
        margin-left: 10px;
    }

    .md-button {
        font-size: 16px;
        font-weight: 600;
        padding: 10px 30px;
        min-width: 150px;
    }

    .title {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 24px;
        line-height: 35px;
        text-align: left;
        color: #666666;
        padding-bottom: 5px;
    }

</style>
